import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'environments/environment';
export class FileClass {
  public id: string;
  public name: string;
  public file: string;
  public mime: string;
  public type: string;
  constructor(encryptedID:string, name: string, file: string, mime: string) {
    this.id = encryptedID;
    this.name = name;
    this.file = file;
    this.mime = mime;
    this.setFileType();
  }

  public getExtension(): string {
    let ext1 = this.name.split('.');
    let file = this.file ? this.file : "";
    let ext2 = file.split('.');
    if (ext1.length > 1) {
      if (ext2.length) {
        if (ext2[ext2.length - 1] !== ext1[ext1.length - 1]) {
          return ext2[ext2.length - 1];
        }
      }
      return ext1[ext1.length - 1];
    }
    if (ext2.length) {
      return ext2[ext2.length - 1];
    }
    return '';
  }

  public view(san: DomSanitizer, appendName: boolean = false, sanitize: boolean = true):SafeResourceUrl {
    if (!san) {
      console.error('Please Provide DomSanitizer');
    }
    let append: string = '';
    if (appendName) {
      append = '/filename/' + this.name;
    }
    let url = `${environment.API_URL}file/view/${this.id}${append}`
    if (sanitize) {
      return san.bypassSecurityTrustResourceUrl(url);
    }
    return url;
  }

  public download(san: DomSanitizer):SafeResourceUrl {
    if (!san) {
      console.error('Please Provide DomSanitizer');
    }
    return san.bypassSecurityTrustResourceUrl(`${environment.API_URL}file/download/${this.id}`);
  }

  private setFileType() {
    let type = 'unknown';
    switch(this.mime.toLowerCase()) {
      case 'application/pdf':
        type = 'pdf';
        break;
      case 'image/jpeg':
      case 'image/pjpeg':
      case 'image/png':
      case 'image/gif':
        type="image";
        break;
      case 'video/mp4':
        type="nativevideo"
        break;
      case 'application/x-3ds':
        if (this.isWebGLEnabled() && this.isFileApiEnabled()) {
          type="threeds";
        } else {
          type="unknown";
        }
        break;
      default:
        type = 'unknown';
        break;
    }
    this.type = type;
  }

  private isWebGLEnabled():boolean {
    if (!(<any>window).WebGLRenderingContext) {
      return false;
    }
    try {
      let canvas = document.createElement ('canvas');
  		if (!canvas.getContext ('experimental-webgl') && !canvas.getContext ('webgl')) {
  			return false;
  		}
    } catch (exception) {
      return false;
    }
    return true;
  }

  private isFileApiEnabled() {
    if (!(<any>window).File || !(<any>window).FileReader || !(<any>window).FileList || !(<any>window).Blob || !(<any>window).URL) {
  		return false;
  	}
  	return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/file.class.ts